import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-job-success-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './cancel-job-success-dialog.component.html',
  styleUrl: './cancel-job-success-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelJobSuccessDialogComponent {
  readonly closeClicked = output<void>();

  onClose(): void {
    this.closeClicked.emit();
  }
}
